import React, { useState, useEffect, useCallback } from 'react'; // Removed useMemo
import { PageHeader, Page, PageContent, Tabs, Tab, Heading, Box, Text, Paragraph } from 'grommet';
import { MapTabContent } from '../../components/MapTabContent';
import { useLocation, useNavigate } from 'react-router-dom';

// Defined outside to maintain referential integrity and satisfy ESLint
const TAB_TITLES = ['ontologies', 'vision', 'agents'];

export const ResearchHome = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Memoized helper to get the tab from the URL
  const getTabIdFromUrl = useCallback(() => {
    const match = location.pathname.match(/\/research\/([a-z-]+)/);
    const id = match ? match[1] : 'ontologies';
    return TAB_TITLES.includes(id) ? id : 'ontologies';
  }, [location.pathname]);

  const [activeLatestTab, setActiveLatestTab] = useState(getTabIdFromUrl());

  // Sync State with URL changes (Back/Forward buttons)
  useEffect(() => {
    const tabIdFromUrl = getTabIdFromUrl();
    if (tabIdFromUrl !== activeLatestTab) {
      setActiveLatestTab(tabIdFromUrl);
    }
  }, [getTabIdFromUrl, activeLatestTab]);

  // Handle Tab Click
  const handleTabChange = (index) => {
    const newTabId = TAB_TITLES[index];
    setActiveLatestTab(newTabId);
    navigate(`/research/${newTabId}`, { replace: true });
  };

  const activeTabIndex = TAB_TITLES.indexOf(activeLatestTab);

  return (
    <Page flex="grow" background="transparent">
      <Box margin={{ top: 'none', left: 'large' }}>
        <PageHeader 
          pad={{ top: '5px', bottom: '20px' }} 
          title={
            <Text size="xxlarge" weight="bold" color="text-strong">
              Research initiatives @ the Lab
            </Text>
          } 
          subtitle={
            <Text size="large" color="text">
              Innovating and incubating to accelerate and modernize
            </Text>
          }
          size='medium'
        />
      </Box> 

      <PageContent flex="grow">
        <Tabs
          activeIndex={activeTabIndex !== -1 ? activeTabIndex : 0}
          onActive={handleTabChange}
          justify="start"
        >
          <Tab title={<Text color="text-strong" weight="bold" size="small">Ontologies</Text>}>
            <MapTabContent>
              <Box pad="medium" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(10px)', borderRadius: '12px' }}>
                <Heading size="small" color="text-strong" margin={{ bottom: 'small' }}>Coming soon...</Heading>
                <Paragraph margin="none" color="text">Ontology research and knowledge graph initiatives coming soon!</Paragraph>
              </Box>
            </MapTabContent>      
          </Tab>

          <Tab title={<Text color="text-strong" weight="bold" size="small">Vision & AI</Text>}>
            <MapTabContent>
              <Box pad="medium" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(10px)', borderRadius: '12px' }}>
                <Heading size="small" color="text-strong" margin={{ bottom: 'small' }}>Coming soon...</Heading>
                <Paragraph margin="none" color="text">AI driven computer vision and recognition research coming soon!</Paragraph>
              </Box>
            </MapTabContent>
          </Tab>  

          <Tab title={<Text color="text-strong" weight="bold" size="small">Advanced Agents</Text>}>
            <MapTabContent>
              <Box pad="medium" style={{ backgroundColor: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(10px)', borderRadius: '12px' }}>
                <Heading size="small" color="text-strong" margin={{ bottom: 'small' }}>Coming soon...</Heading>
                <Paragraph margin="none" color="text">Advanced AI agent applications and orchestration coming soon!</Paragraph>
              </Box>
            </MapTabContent>
          </Tab>                     
        </Tabs>
      </PageContent>  
    </Page>
  );
};